import { Switch } from "@mantine/core";

interface Props {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default function PrivilegeToggle({ label, checked, onChange }: Props) {
  return (
    <div className="flex items-center justify-between border rounded-lg px-3 py-2">
      <span className="text-sm">{label}</span>
      <Switch
        checked={checked}
        onChange={(e) => onChange(e.currentTarget.checked)}
      />
    </div>
  );
}
